import React, { useEffect, useRef, useState } from 'react'
import './SalesCalender.css'
import FullCalendar from "@fullcalendar/react";
import { Col, Row, Radio, Button, Dropdown, Badge, Calendar } from 'antd'
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import images1 from '../../assets/images1.jfif'
import { BASE_URL, FetchAttendanceCalendar } from '../../utils/constant';
import moment from 'moment';
function SalesCalender({salesDepartmentId , selectedYearNumber, selectedMonthNumber}) {
console.log('staffData',selectedYearNumber)
console.log('selectedMonthNumber',selectedMonthNumber)
  const [randNumber, setRandNumber] = useState(0);
  const [staffCalendarData, setStaffCalendarData] = useState([]);
  const [events, setEvents] = useState([]);
  const capitalizeFirstLetter = (str) => {
    return str?.replace(/\b\w/g, (char) => char.toUpperCase());
  };

  useEffect(() => {
    getStaffDayList();
  }, [selectedMonthNumber]);

  const getStaffDayList = async () =>{
    const token = localStorage.getItem('authToken');
  
    const fetchData = async () => {
      const response = await fetch(`${BASE_URL}/${FetchAttendanceCalendar}`, {
        method: "POST",
         headers: {
                  'Content-Type': 'application/json',
                  'Authorization': `${token}`,
                  
                },
        body: JSON.stringify({
            "staffId" : salesDepartmentId,
            "month" : parseInt(selectedMonthNumber),
            "year" : parseInt(selectedYearNumber)
        }),
      });
      
      if (response.ok) {
        const data = await response.json();
        setStaffCalendarData(data?.data)
        console.log('StaffCalendar',data)
        const mappedEvents = data?.data?.staffAttendanceDetails.map(item => ({
          title: 'Your Event Title',
          item:item,
          start: item?.attendanceDate,
          end: item?.attendanceDate, // Set the end time as the same date for simplicity
          checkInTime: item?.checkInTime !== undefined && 
          formatTimeWithAMPM(item?.checkInTime) !== undefined  ? formatTimeWithAMPM(item?.checkInTime) : '--' ,
          checkOutTime: item?.checkOutTime !== undefined && 
          formatTimeWithAMPM(item?.checkOutTime) !== undefined ? formatTimeWithAMPM(item?.checkOutTime) : '--' ,
          totalWorkingHr: item?.totalWorkingHr ? formatTime(item?.totalWorkingHr) : '--' ,
          location : Object.keys(item?.checkInLocationDetail).length === 0 ? '--' : item?.checkInLocationDetail?.locationName2,
          attendance : item?.isAbsent || 
                       item?.isAbsent == false && item?.isWeeklyOff == false && item?.isStaffOut == false && item?.isStaffIn == false  ? <span className='a ml-auto mr-1'>A</span>
                       : item?.isAbsent == false && item?.isWeeklyOff == true  && item?.isStaffOut == true  ? <span className='w-[22px] h-[22px] rounded-full bg-[#21AF3A]'>P</span>
                       : item?.isAbsent == false && item?.isWeeklyOff == true  && item?.isStaffOut == false ? <span className='Ot ml-auto mr-1'>WO</span>
                       : item?.isStaffHalfDay ? <span className='Ot ml-auto mr-1'>HD </span>
                       : <span className='w-[22px] h-[22px] rounded-full bg-[#21AF3A]' >P </span>,
                      
        }));
  
        setEvents(mappedEvents)
      } else {
        const data = await response.json();
        console.log('stafTodayerr',data)
        // toast.error(data.errorMessage, {
        //   position: toast.POSITION.TOP_RIGHT,
        // });
        
      }
    };
   
    await fetchData();
   
  }
  const eventRender = (info) => {
    console.log('info',info)
    
  };
  useEffect(() => {
    setRandNumber(Math.random());
  }, []);
  const calendarEvents = [
// const calendarEvents =
 staffCalendarData?.staffAttendanceDetails?.map((attendance) => ({
    allDay: false,
    id: 1,
    title: "GEN-A",
    start: attendance.attendanceDate ? new Date(attendance.attendanceDate) : null,
    end: attendance.attendanceDate ? new Date(attendance.attendanceDate) : null,
    description: <><p style={{fontSize:'10px'}}>{attendance.createdAt} - 06:00 PM</p></>,
    company:<> <span className='keshar'>Keshar Towars</span></>,
  }))];
  function formatTime(milliseconds) {
    const hours = Math.floor(milliseconds / 3600000);
    const minutes = Math.round((milliseconds % 3600000) / 60000);
  
    if (hours > 0) {
      return `${hours}:${minutes < 10 ? '0' : ''}${minutes} H`;
    } else {
      return `${minutes} m`;
    }
  }
  function formatTimeWithAMPM(milliseconds) {
    const hours = Math.floor(milliseconds / 3600000);
    const minutes = Math.round((milliseconds % 3600000) / 60000);
  
    const formattedHours = hours % 12 || 12;
    const ampm = hours >= 12 ? 'PM' : 'AM';
  
    return `${formattedHours}:${minutes < 10 ? '0' : ''}${minutes} ${ampm}`;
  }
  const [calendarState, setCalendarState] = useState({
    initialDate: new Date(selectedYearNumber, selectedMonthNumber - 1, 1), // Initial date to display
});

const calendarRef = useRef(null);



useEffect(() => {
    if (calendarRef.current !== null) {
        calendarRef.current.getApi().gotoDate(calendarState.initialDate);
    }
}, [calendarState.initialDate]);

// Update the initialDate when selectedYearNumber or selectedMonthNumber changes
useEffect(() => {
    setCalendarState(prevState => ({
        ...prevState,
        initialDate: new Date(selectedYearNumber, selectedMonthNumber - 1, 1)
    }));
}, [selectedYearNumber, selectedMonthNumber]);
const dynamicStyles = staffCalendarData?.staffAttendanceDetails?.map(item => {
  if (item?.isAbsent === false && item?.isWeeklyOff === true && item?.isStaffOut === false) {
    console.log('item?.attendanceDate',moment(item?.attendanceDate).format("YYYY-MM-DD"))
      return `
          .fc-day[data-date="${moment(item?.attendanceDate).format("YYYY-MM-DD")}"] .fc-daygrid-day-frame {
              background: #DDEDF7 !important;
          }
      `;
  }
  return '';
}).join('');
  return (
    <div>
      <Col lg={32}>
    
          <div key={randNumber} className='ml-2 calendarMainHistory [&_.fc-daygrid-day-events]:!mb-0 [&_.fc-col-header-cell-cushion]:!text-[#4B8AEB] [&_.fc-col-header-cell-cushion]:uppercase [&_.fc-daygrid-day-frame]:!bg-[#F2F2F2] [&_.fc-daygrid-day-number]:!text-[14px] [&_.fc-daygrid-day-number]'>
          <style>
                        {dynamicStyles}
                    </style>
            <FullCalendar
              plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
                headerToolbar={{
                  left: 'title',
                  center:'',
                  right:''
                }}
              events={events}
              dayMaxEventRows={3}
              aspectRatio={2}
              height="auto"
              width="auto"
              eventMinHeight={30}    
              eventDisplay="block"
              backgroundColor="red"
              ref={calendarRef}
              eventContent={(event) => {
                return (
                  <div className={`flex flex-col px-2`}>
                    
                   { event.event.extendedProps?.item?.isAbsent || 
                       event.event.extendedProps?.item?.isAbsent == false && event.event.extendedProps?.item?.isWeeklyOff == false && event.event.extendedProps?.item?.isStaffOut == false && event.event.extendedProps?.item?.isStaffIn == false ?
                    (
                    <div className='absentD'>A</div>
                  ) 
                  : event.event.extendedProps?.item?.isStaffHalfDay ? 
                 ( <div className='HalfD'>HD</div> )
                  : event.event.extendedProps?.item?.isAbsent == false && event.event.extendedProps?.item?.isWeeklyOff == true  && event.event.extendedProps?.item?.isStaffOut == false && event.event.extendedProps?.item?.isStaffIn == false ? 
                 ( <div className='wo'>W/O</div> )
                  : (
                    <>
                    <div className='d-flex firstLine'>

                    <span className="text-[#0F94AF] text-[13px] flex-1">{event.event.extendedProps?.totalWorkingHr} </span>
                      {event.event.extendedProps?.attendance}
                    </div>
                    <span className="text-[13px] text-black">{event.event.extendedProps?.checkInTime } - {event.event.extendedProps?.checkOutTime}</span>
                    <hr />
                    <div className='flex items-center justify-center gap-2 py-2'>

                    <span className="text-[13px] text-[#0F94AF] leading-none">{capitalizeFirstLetter(event.event.extendedProps?.item?.shiftDetail?.shiftShortName)}</span>
                    <span className="text-xs text-[#7B7B7B] leading-none">{formatTimeWithAMPM(event.event.extendedProps?.item?.shiftDetail?.shiftStartTime)} - {formatTimeWithAMPM(event.event.extendedProps?.item?.shiftDetail?.shiftEndTime)}</span>
                    </div>
  
                    </>
                    )
                   }
                  </div>
                   )}}
                  
              weekNumberCalculation="ISO"
            />
             
          </div>
        </Col>
    </div>
  )
}

export default SalesCalender